import { render, staticRenderFns } from "./Merchant.vue?vue&type=template&id=0403a19c&"
import script from "./Merchant.vue?vue&type=script&lang=js&"
export * from "./Merchant.vue?vue&type=script&lang=js&"
import style0 from "./Merchant.vue?vue&type=style&index=0&id=0403a19c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports